import { render, staticRenderFns } from "./Creator.vue?vue&type=template&id=72b1ba4e&scoped=true&"
import script from "./Creator.vue?vue&type=script&lang=js&"
export * from "./Creator.vue?vue&type=script&lang=js&"
import style0 from "./Creator.vue?vue&type=style&index=0&id=72b1ba4e&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72b1ba4e",
  null
  
)

export default component.exports